module.exports = __webpack_public_path__ + "img/75574.c9b0913b.svg";